export const formatActivityPatient = patient => {
  if (!patient) {
    return '-'
  }

  const surname = patient.surname || '-'
  const name = patient.name || ''
  const fullName = `${surname} ${name}`.trim()

  return patient.pesel ? `${fullName} (${patient.pesel})` : fullName
}

export default formatActivityPatient
